import {RegionalCore} from './regionales-core.model';
import {DetailField} from '../../../shared/models/detail.model';

export const REGIONALESCOREDETAIL_DEFAULT_FIELDS: DetailField[] = [
  { name: 'regionalNombre', label: 'Nombre' },
];

export interface RegionalesCoreDetailParams {
  regional: RegionalCore;
  fields?: DetailField[];
}
